import { http } from 'services/http';
import { CARGO_GET_ONE, CARGO_ITEMS_MANY } from 'api/query-keys.ts';
import type { CargoItemRes } from 'api/swagger';
import { useMutationBase } from 'shared/hooks/use-mutation-base.ts';

interface IDeleteCargoItemsVariables {
  cargoId: number;
  cargoItemsIds: number[];
}

export const useDeleteCargoItems = () => {
  return useMutationBase<CargoItemRes, unknown, IDeleteCargoItemsVariables>({
    mutationFn: async (variables) => {
      const { cargoId, cargoItemsIds } = variables;
      const res = await http.delete<CargoItemRes>(`/v1/cargo/${cargoId}/cargo-items`, {
        data: { cargoItemsIds },
      });

      return res.data;
    },

    invalidateCallback: (_, { cargoId }) => [
      [CARGO_GET_ONE, cargoId],
      [CARGO_ITEMS_MANY, cargoId],
    ],
  });
};
